//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import dashboard from "apis/dashboard/dashboard";
import "assets/css/custom.css";
import Context from "context/context";
import redeem from "apis/redeem/redeem";
import { redeemConfirmationStyles } from "./styles";
import Loader from "components/Loader/Loader";
import Gold from "assets/img/gold-level.png";
import Silver from "assets/img/silver-level.png";
import Platinum from "assets/img/platinum-level.png";
import Bronze from "assets/img/bronze-level.png";
import PointsCard from "views/Dashboard/Dashboard/Components/PointsCard";
import { useTranslation } from 'react-i18next';
import { imageHandler } from "helpers/imageHandler";

// material-ui
import Grid from "@material-ui/core/Grid";
import { currencyFormat, pointsFormat } from "helpers/dataFormat";
// material-ui icons

export default function RedemptionConfirmation() {
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const location = useLocation();
  const classes = redeemConfirmationStyles();
  const { getPoints, getBillingAccount } = dashboard();
  const { t, i18n } = useTranslation()
  const [states, setstates] = useState({});
  const org = state?.userInfo?.loyalty_organization_name;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      if (state?.ALA?.["Loyalty_Account.is_active"]) {
        return;
      } else {
        history.push("/dashboard/loyalty");
      }
    }
  }, [state.ALA]);

  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "REDEEM MY POINTS"] });
  }, []);

  // handling points api call
  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      handleGetPoints();
      handleGetBillingAccount();
      return;
    }
  }, [state.ALA]);

  // points api func
  const handleGetPoints = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      let values = state.ALA.loyalty_id;
      setStates({ loading: true });
      let res = await getPoints(values);
      if (res) {
        setStates({ points: res });
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // Billing Account api func
  const handleGetBillingAccount = async () => {
    try {
      let values = state.ALA.loyalty_id;
      let res = await getBillingAccount(values);
      if (res) {
        dispatch({ type: "SET_BILLINGACCOUNT", payload: res?.data });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // tier image switch case
  const getLoyalityAccountLevel = (level) => {
    switch (level) {
      case "Gold": {
        return Gold;
      }
      case "Silver": {
        return Silver;
      }
      case "Bronze": {
        return Bronze;
      }
      case "Platinum": {
        return Platinum;
      }
    }
  };

  // const pointFormat = (point) => {
  //   var nfObject = new Intl.NumberFormat("en-US");
  //   var res = nfObject.format(point);
  //   return res;
  // };

  return (
    <React.Fragment key="1">
      <PointsCard loyaltyId={state.ALA.loyalty_id} />
      <Grid container spacing={0}>
        <Grid item xs={12} className={classes.contentGrid}>
          <div className={classes.content1}>
            <img
              src={org == "Henry Schein Dental"?imageHandler?.[org]?.[i18n?.language]?.["NewCongrulations"]:imageHandler?.[org]?.[i18n?.language]?.["congratulationLogo"]}
              alt=""
              width={org == "Henry Schein Dental"?"75%":"40%"}
              className={classes.congratsImg}
            />
          </div>
          <div className={classes.threeBtnsGrid}>
            <div className={classes.btnSection}>
              <div style={{ fontSize: 16, fontWeight: "bold" }}>
                {t('You have redeemed')}
              </div>
              <button className={classes.pointsBalanceBtn}>
                {location?.state?.redeemedPoints
                  ? pointsFormat(location?.state?.redeemedPoints, i18n?.language)
                  : 0}
              </button>
              <div style={{ fontSize: 16, fontWeight: "bold" }}>{t('points')}</div>
            </div>
            <div className={classes.btnSection}>
              <div style={{ fontSize: 16, fontWeight: "bold" }}>
                {t('Your account will be credited')}
              </div>
              <button className={classes.pointsBalanceBtn}>
                {location?.state?.redeemedPointsDollar
                  ? currencyFormat(location?.state?.redeemedPointsDollar,
                    i18n?.language,
                    state?.userInfo?.loyalty_organization_name                    
                  )
                  : 0}
              </button>
            </div>
            <div className={classes.btnSection}>
              <div style={{ fontSize: 16, fontWeight: "bold" }}>
                {t('Your new points balance is')}
              </div>
              <button className={classes.pointsBalanceBtn}>
                {location?.state?.pointsBalance
                  ? pointsFormat(location?.state?.pointsBalance, i18n?.language)
                  : 0}
              </button>
            </div>
          </div>
          <div className={classes.content4}>
            {t('Thank you for submitting your redemption order. You will receive an email confirmation within 24 hours')}.
          </div>
          <div className={classes.content5}>
            <span
             className={
              state?.userInfo?.loyalty_organization_name === "Henry Schein Canada"
                ? classes.content5Spanca
                : classes.content5Span
            }
              onClick={() => {
                history.push({
                  pathname: "/dashboard/dashboard",
                  state: {
                    redeemed: true,
                  },
                });
              }}
            >
              {t('Click Here to View Your Transaction Activity')}
            </span>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
